export default __webpack_public_path__ + "assets/front/scss/user-profile.78cce4921c723f633f2cca1bdffdd283.css";